import React from 'react';
export function Footer() {
  return <footer className="bg-black py-10 border-t border-zinc-800" data-id="element-205">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-206">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-207">
          <div className="mb-6 md:mb-0" data-id="element-208">
            <div className="font-light text-xl text-slate-300" data-id="element-209">
              Saense Beveiliging
            </div>
            <div className="text-zinc-400 text-base mt-2" data-id="element-210">
              Professioneel Beveiliger | Assendelft
            </div>
          </div>
          <div className="flex items-center gap-6 mb-6 md:mb-0" data-id="element-211">
            <a href="https://www.kilicsecurityservices.nl/wp-content/uploads/2025/08/CV_Ahmet_Uzun.pdf" target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-slate-300 transition-colors text-base" data-id="element-212">
              CV Downloaden
            </a>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-zinc-800 text-sm text-zinc-500 text-center" data-id="element-213">
          <p data-id="element-214">KVK: 92847927 | BTW: NL004981622B39 | Saense Beveiliging</p>
          <p className="mt-2" data-id="element-215">
            &copy; {new Date().getFullYear()} SaenseBeveiliging.nl. Alle rechten
            voorbehouden.
          </p>
        </div>
      </div>
    </footer>;
}